import './partials/cookies';
import './partials/customDimensions';
import './partials/toggleSearchButton';
